/*
 * blog-loadmore.js -- AJAX „Načíst další" na výpisu blogu (14-02, TASK AY).
 *
 * NÁLEZ MAJITELE (7. 9. 2026, doslova): „po kliknutí na Načíst další se
 * aditivně přidají další články, ale ty vyroluješ stránku zase nahoru, to
 * musí zůstat kde jsem, a jen se pod načtou další články".
 *
 * PŘÍČINA (citace `template-parts/blog-listing.php`, stav před tímhle
 * plánem): `.loadmore` bylo `<a href="{next_url}">` -- obyčejný odkaz na
 * `/blog/page/N/`. Klik spustil PLNOU navigaci prohlížeče; ta vždy
 * scrolluje na vrchol nového dokumentu (bez `#fragmentu` není důvod
 * nescrollovat) a nový dokument NENAHRAZUJE dosavadní seznam přídavkem --
 * je to úplně nová stránka. Oprava tenhle modul: fetch další stránky,
 * vytáhne z ní jen karty (`#posts .bpost`) a připojí je pod stávající,
 * beze změny scrollu a bez plné navigace.
 *
 * PROČ FETCH CELÉ STRÁNKY, NE VLASTNÍ ENDPOINT. `home.php`/`category.php`
 * i tak vykreslují `blog-listing.php` pro parametr `page/N/` -- žádný nový
 * REST endpoint není potřeba, odpověď se jen parsuje přes `DOMParser` a
 * vezme se z ní totéž `#posts`, které server posílá při běžné navigaci.
 * Nová odpověď nese I SVÉ VLASTNÍ tlačítko `[data-loadmore]` s další
 * `data-next-url` (nebo žádné, když další stránka není) -- řetězec stránek
 * se tak posouvá bez vlastní stavové logiky nad číslem stránky.
 *
 * PROČ JEN `.bpost`, NE CELÝ `#posts.innerHTML`. Stránka 2+ nemá
 * `featured` kartu (jen stránka 1), ale MÁ vlastní `.ctacard`/`.ctamini`
 * (`blog-listing.php`, řádek s `terrahunt_2026_render_ctacard()` po
 * čtvrtém článku a `terrahunt_2026_render_ctamini()` na konci) -- kdyby se
 * připojoval celý obsah `#posts`, zdvojily by se CTA dlaždice uprostřed
 * i na konci seznamu. Připojují se proto jen samotné karty článků, VŽDY
 * na konec stávajícího seznamu (za existující CTA dlaždice), což přesně
 * odpovídá bráně úkolu (nové karty pod poslední původní).
 *
 * MIMO BLOG NEDĚLÁ NIC. Bez `[data-loadmore]` v DOM se modul vrátí dřív,
 * než zaregistruje jediný posluchač (stejný vzor jako `blog-filter.js`).
 */

export function init() {
	const trigger = document.querySelector( '[data-loadmore]' );

	if ( ! trigger ) {
		return;
	}

	const list = document.getElementById( 'posts' );

	if ( ! list ) {
		return;
	}

	const status = document.querySelector( '[data-loadmore-status]' );
	let busy = false;

	trigger.addEventListener( 'click', function ( event ) {
		/*
		 * `type="button"` uvnitř `.wrap` bez `<form>` navigaci ani submit
		 * sám o sobě nespouští -- `preventDefault()` tu stojí jako pojistka
		 * (stejný vzor jako `blog-filter.js` u chipů), ne proto, že by bez
		 * něj něco uteklo.
		 */
		event.preventDefault();

		if ( busy ) {
			return;
		}

		const url = trigger.getAttribute( 'data-next-url' ) || '';

		if ( '' === url ) {
			return;
		}

		busy = true;
		trigger.disabled = true;

		fetch( url, { credentials: 'same-origin' } )
			.then( function ( response ) {
				if ( ! response.ok ) {
					throw new Error( 'blog-loadmore: HTTP ' + response.status );
				}

				return response.text();
			} )
			.then( function ( html ) {
				const doc = new DOMParser().parseFromString( html, 'text/html' );
				const noveKarty = [].slice.call( doc.querySelectorAll( '#posts .bpost' ) );

				if ( ! noveKarty.length ) {
					busy = false;
					trigger.disabled = false;

					return;
				}

				const fragment = document.createDocumentFragment();

				noveKarty.forEach( function ( karta ) {
					fragment.appendChild( document.importNode( karta, true ) );
				} );

				const pocetPred = list.querySelectorAll( '.bpost' ).length;

				/*
				 * `appendChild` na živý `#posts`, ŽÁDNÝ `innerHTML` re-render --
				 * existující karty (a jejich případný stav z `blog-filter.js`,
				 * na blogu bez chipů) zůstávají netknuté, jen přibude fragment
				 * za nimi. Scroll se tímhle krokem vůbec nemění (žádné volání
				 * `scrollIntoView`/`scrollTo`).
				 */
				list.appendChild( fragment );

				const dalsiTlacitko = doc.querySelector( '[data-loadmore]' );
				const dalsiUrl = dalsiTlacitko ? dalsiTlacitko.getAttribute( 'data-next-url' ) || '' : '';
				const wrapper = trigger.closest( '.loadmore' );

				if ( '' !== dalsiUrl ) {
					trigger.setAttribute( 'data-next-url', dalsiUrl );
					trigger.disabled = false;
				} else if ( wrapper ) {
					/* Poslední stránka: tlačítko dál nemá kam vést -- schová se celé (D4, stejný gate jako SSR vynechání bloku). */
					wrapper.hidden = true;
				}

				/*
				 * `history.replaceState`, NE `pushState` a NE scroll. Adresní
				 * řádek odráží, na které stránce výpisu uživatel skutečně je
				 * (obnovení stránky/sdílený odkaz vrátí totéž okno), ale nová
				 * položka v historii by přidala krok navíc do tlačítka Zpět
				 * a s ním riziko, že by prohlížeč při návratu obnovil scroll
				 * na starou pozici stránky 1 -- přesně to, co nález žádal
				 * NEDĚLAT.
				 */
				if ( window.history && 'function' === typeof window.history.replaceState ) {
					window.history.replaceState( null, '', url );
				}

				const vsechnyKarty = list.querySelectorAll( '.bpost' );
				const prvniNovaKarta = vsechnyKarty[ pocetPred ];
				const cilFokusu = prvniNovaKarta ? prvniNovaKarta.querySelector( 'h3 a' ) : null;

				/*
				 * `preventScroll: true` je jádro opravy: bez něj by `focus()`
				 * sám posunul viewport na nově vloženou kartu, tedy přesně ten
				 * skok, který nález popisuje (jen o úroveň níž -- „nahoru" by
				 * se změnilo na „na konec seznamu", pořád ne tam, kde uživatel
				 * byl).
				 */
				if ( cilFokusu && 'function' === typeof cilFokusu.focus ) {
					cilFokusu.focus( { preventScroll: true } );
				}

				if ( status ) {
					const sablona = trigger.getAttribute( 'data-announce' ) || '';

					status.textContent = sablona ? sablona.replace( '%d', String( noveKarty.length ) ) : '';
				}

				busy = false;
			} )
			.catch( function () {
				/*
				 * Fail-open: AJAX selhal (síť/5xx), ale `data-next-url` pořád
				 * míří na skutečnou stránku výpisu -- degradace na PŮVODNÍ
				 * (funkční, byť skokové) chování, ne na mrtvé tlačítko.
				 */
				busy = false;
				trigger.disabled = false;
				window.location.href = url;
			} );
	} );
}
